import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { LangProvider } from "./contexts/LangContext";
import { DashboardLayout } from "./components/Layout";
import SuperAdminLayout from "./components/SuperAdminLayout";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import StorePage from "./pages/StorePage";
import EmployeePage from "./pages/EmployeePage";
import ProductPage from "./pages/ProductPage";
import VendorPage from "./pages/VendorPage";
import CustomerPage from "./pages/CustomerPage";
import VoucherPage from "./pages/VoucherPage";
import WithdrawalPage from "./pages/WithdrawalPage";
import SettingsPage from "./pages/SettingsPage";
import InvitePage from "./pages/InvitePage";
import LandingPage from "./pages/LandingPage";
import CategoryPage from "./pages/CategoryPage";
import SuperLoginPage from "./pages/superbackend/SuperLoginPage";
import SuperUsersPage from "./pages/superbackend/SuperUsersPage";
import SuperPackagesPage from "./pages/superbackend/SuperPackagesPage";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#F6F5F5] flex items-center justify-center">
        <div className="w-10 h-10 border-3 border-[#EB7B44] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <DashboardLayout>{children}</DashboardLayout>;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/app" replace />;
  return children;
};

const SuperProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('sellmu_super_token');
  if (!token) return <Navigate to="/superbackend/login" replace />;
  return <SuperAdminLayout>{children}</SuperAdminLayout>;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public Landing */}
      <Route path="/" element={<LandingPage />} />

      {/* Auth */}
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
      <Route path="/invite/:token" element={<InvitePage />} />

      {/* Admin Dashboard */}
      <Route path="/app" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/app/stores" element={<ProtectedRoute><StorePage /></ProtectedRoute>} />
      <Route path="/app/stores/:storeId/employees" element={<ProtectedRoute><EmployeePage /></ProtectedRoute>} />
      <Route path="/app/categories" element={<ProtectedRoute><CategoryPage /></ProtectedRoute>} />
      <Route path="/app/products" element={<ProtectedRoute><ProductPage /></ProtectedRoute>} />
      <Route path="/app/vendors" element={<ProtectedRoute><VendorPage /></ProtectedRoute>} />
      <Route path="/app/customers" element={<ProtectedRoute><CustomerPage /></ProtectedRoute>} />
      <Route path="/app/vouchers" element={<ProtectedRoute><VoucherPage /></ProtectedRoute>} />
      <Route path="/app/withdrawals" element={<ProtectedRoute><WithdrawalPage /></ProtectedRoute>} />
      <Route path="/app/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />

      {/* Super Admin */}
      <Route path="/superbackend/login" element={<SuperLoginPage />} />
      <Route path="/superbackend" element={<SuperProtectedRoute><SuperUsersPage /></SuperProtectedRoute>} />
      <Route path="/superbackend/packages" element={<SuperProtectedRoute><SuperPackagesPage /></SuperProtectedRoute>} />

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LangProvider>
          <AppRoutes />
        </LangProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
